module.exports = __webpack_public_path__ + "img/finland-transport-accidents-female.daa4b0e8.png";